import { useQuery, UseQueryResult } from 'react-query';
import pDebounce from 'p-debounce';

import { getTokenWithType } from './useAuth';

import { customLookupTables } from '../utils/urls';

import { CustomTable } from 'types/customTables';
import { ErrorModal } from 'types/modalTypes';

async function fetchLookups({ accountId }: TVariables): Promise<APIResult> {
  const response = await fetch(customLookupTables(accountId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

const debouncedFetch = pDebounce(fetchLookups, 500);

type TError = ErrorModal;

type APIResult = {
  Data: Array<CustomTable>;
  IsSuccess: boolean;
  StatusCode: number;
};

type ResultItem = {
  id: number;
  name: string;
};
type TResult = Array<ResultItem>;

type TVariables = {
  accountId: number;
};

function useGetLookups(accountId: number): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_look_ups',
    async () => {
      const fetchResponse = await debouncedFetch({
        accountId,
      });
      const result = fetchResponse.Data.map(lookup => ({
        id: lookup.Id,
        name: lookup.TableName,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetLookups };
